export type PremiumUsp = {
  label: string;
  tooltip?: string;
};

export const premiumUsps: PremiumUsp[] = [
  { label: 'dialogs.premium.usp.1' },
  { label: 'dialogs.premium.usp.2' },
  { label: 'dialogs.premium.usp.3', tooltip: 'dialogs.premium.usp.3.tooltip' },
  { label: 'dialogs.premium.usp.4', tooltip: 'dialogs.premium.usp.4.tooltip' },
  { label: 'dialogs.premium.usp.5' },
  { label: 'dialogs.premium.usp.6', tooltip: 'dialogs.premium.usp.6.tooltip' },
  { label: 'dialogs.premium.usp.7' },
  { label: 'dialogs.premium.usp.8', tooltip: 'dialogs.premium.usp.8.tooltip' },
  { label: 'dialogs.premium.usp.9' },
  { label: 'dialogs.premium.usp.10' },
];
